import { ask } from '@monorepo/tools/src/lib/tools/ask/ask';
import { IPerformanceOptions } from '../hooks/apis/use-reports-list';
import endpoints from './endpoints/index.endpoints';
import { ReportResponse } from '../models/report.model';

export const AdminxReporterApi = {
	report: async <T>(params: IPerformanceOptions): Promise<ReportResponse<T>> => {
		const res = await ask.post(endpoints.report.report(), params);
		const payload = new ReportResponse<T>(res.payload);
		return payload;
	},
};
